import { Container } from '@mui/material';
import { IApiCallStatus, ValueLabel } from '../common';
import { render, IStatusLegacy } from '.';

export function RequestStatus2d({
  properties,
  requests,
  getRequstsCallStatus,
}: {
  properties: ValueLabel<string>[];
  requests: IStatusLegacy[];
  getRequstsCallStatus: IApiCallStatus;
}) {
  switch (getRequstsCallStatus) {
    case null:
      return <Container maxWidth="lg">Loading...</Container>;

    case false:
      return <Container maxWidth="lg">Error</Container>;

    case true:
      return render(properties)(requests);

    case void 0:
      return null;

    default:
      return <Container maxWidth="lg">Idk</Container>;
  }
}
